import * as patient from './patient';
import * as addPatient from './add-patient';
import * as patientList from'./patient-list';
import * as auth from './auth';
import * as app from './app';

export {
  patient,
  addPatient,
  patientList,
  auth,
  app
}



// WEBPACK FOOTER //
// ./src/actions/index.js